import React, { Fragment } from 'react';
import { func, arrayOf, shape, string } from 'prop-types';

import Helmet from 'react-helmet';

import styled from 'styled-components';
import { Button, Popup } from 'semantic-ui-react';

import Heading from '~/views/common/Heading';
import CreateForm from './CreateForm';

import { fmt } from '~/utils';


const List = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
`;

const Item = styled.li`
    display: flex;
    align-items: center;
    padding: 8px 4px;
    border-radius: 6px;
`;

const Name = styled.span`
    font-weight: bold;
    margin-left: 1rem;
`;

const Description = styled.span`
    font-style: italic;
    color: ${p => p.theme.color.gray};
`;

const FeatureFlags = ({
    feature_flags = [],
    handleDeleteFlag,
    ...formProps
}) => (
    <Fragment>
        <Helmet title="Feature Flags" />

        <Heading iconName="flag" header="Feature Flags" />

        <List>
            { feature_flags.map(({ name, description }) => (
                <Item key={name}>
                    <Popup
                        trigger={
                            <Button
                                basic
                                color="red"
                                circular
                                icon="trash"
                                type="button"
                            />
                        }
                        content={
                            <Button
                                type="button"
                                color="green"
                                content="Confirm"
                                onClick={() => handleDeleteFlag(name)}
                            />
                        }
                        on="click"
                        position="right center"
                    />
                    <Name>
                        { fmt(name) }
                    </Name>
                    { description &&
                        <Description>&nbsp;&nbsp;{ description }</Description>
                    }
                </Item>
            )) }
        </List>

        <CreateForm {...formProps} />
    </Fragment>
);

FeatureFlags.propTypes = {
    feature_flags: arrayOf(shape({
        name: string.isRequired,
        description: string,
    })),
    handleDeleteFlag: func.isRequired,
};

export default FeatureFlags;
